import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import CursorEffect from './components/CursorEffect'
import Home from './pages/Home'
import Features from './pages/Features'
import Download from './pages/Download'
import Docs from './pages/Docs'
import OpenCenter from './pages/OpenCenter'
import Manual from './pages/manual/Manual'
import DesignShowcase from './pages/DesignShowcase'
import ScrollToTop from './components/ScrollToTop'
import { LanguageProvider } from './contexts/LanguageContext'
import { useWebsiteVisitTracking } from './hooks/useWebsiteVisitTracking'

function WebsiteVisitTracker() {
  useWebsiteVisitTracking()
  return null
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <WebsiteVisitTracker />
        <div className="min-h-screen flex flex-col">
        {/* 粒子背景 */}
        <div className="particles-bg"></div>
        
        {/* 自定义光标效果 */}
        <CursorEffect />
        
        {/* 导航栏 */}
        <Navbar />
        
        {/* 滚动到顶部组件 */}
        <ScrollToTop />
        
        {/* 主内容 */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/download" element={<Download />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/docs/:section" element={<Docs />} />
            <Route path="/open-center" element={<OpenCenter />} />
            <Route path="/open-center/:section" element={<OpenCenter />} />
            <Route path="/manual" element={<Manual />} />
            {/* 设计展示页面 - 仅用于开发测试 */}
            <Route path="/design-showcase" element={<DesignShowcase />} />
          </Routes>
        </main>
        
        {/* 页脚 */}
        <Footer />
      </div>
    </Router>
    </LanguageProvider>
  )
}

export default App
